import React, { ElementType, FC } from "react";
import classNames from "classnames";

/**
 * Proposal for a Heading component. We should consider making this an
 * official Kaleidoscope component
 */

export interface HeadingProps {
  /**
   * Sepcify the html element rendered by the heading
   */
  as?: ElementType;
  /**
   * Specify the heading level. Determines the rendered `<h1>`,
   * `<h2>` etc unless overidden by the `as` prop
   */
  level: 1 | 2 | 3 | 4;
  /**
   * Truncates text overflow with ellipsis
   */
  truncate?: boolean;
  weight?: HeadingWeight;
  align?: HeadingAlign;
  className?: string;
  id?: string;
}

export enum HeadingWeight {
  Normal = "normal",
  Strong = "strong",
}

export enum HeadingAlign {
  Start = "start",
  Center = "center",
}

const Heading: FC<HeadingProps> = ({
  children,
  as: Component,
  level,
  weight = HeadingWeight.Normal,
  align = HeadingAlign.Start,
  truncate,
  className,
  id,
}) => {
  // Allow the rendered element to be independent from the stylistic level.
  // Useful for maintaining ordering for a11y
  const HeadingElement = Component || `h${level}`;

  return (
    <HeadingElement
      className={classNames(
        className,
        "kl-heading",
        `kl-heading--level-${level}`,
        `kl-heading--weight-${weight}`,
        `kl-heading--align-${align}`,
        {
          "kl-heading--truncate": truncate,
        },
      )}
      id={id}
    >
      {children}
    </HeadingElement>
  );
};

export default Heading;
